import { render, staticRenderFns } from "./WireTransferList.vue?vue&type=template&id=f4d70f44&scoped=true"
import script from "./WireTransferList.vue?vue&type=script&lang=js"
export * from "./WireTransferList.vue?vue&type=script&lang=js"
import style0 from "./WireTransferList.vue?vue&type=style&index=0&id=f4d70f44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d70f44",
  null
  
)

export default component.exports